import { reset } from 'redux-form';
import { sendNotifications } from '../../../helpers/push-notification/sendNotifications'
import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
	try {
		let content = {
			title: values.title + ' Notification!',
			message: values.message
		}
		let userType = values.to;
		const isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		dispatch(setLoaderStart('sendNotification'));

		sendNotifications('notification', content, null, userType)
			.then(() => {
				dispatch(reset('ManageNotificationsForm'));
			})
			.catch(error => {
				showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
			})
			.finally(() => {
				dispatch(setLoaderComplete('sendNotification'));
			});
	} catch (error) {
		showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
	}
}

export default submit;
